module.exports = __webpack_public_path__ + "static/media/investor_boost.26d3b66f.png";